import { NO_CATALOG } from "../../api/config"
import type { Catalog } from "../../api/types"
import { splitCatalogs } from "./rules"

/** Каталог задаёт область выборки справочника: сайты Риги, четыре печатных
 *  каталога и псевдокаталог «Вне каталогов». */
export default function CatalogSelect({
	catalogs,
	rigaSites,
	value,
	onChange,
}: {
	catalogs: Catalog[]
	rigaSites: Set<string>
	value: number
	onChange: (value: number) => void
}) {
	const { riga, printed } = splitCatalogs(catalogs, rigaSites)

	return (
		<select
			className="select"
			value={value}
			onChange={event => onChange(Number(event.target.value))}
		>
			<option value={NO_CATALOG}>Вне каталогов</option>
			<optgroup label="Сайты Риги">
				{riga.map(catalog => (
					<option key={catalog.id} value={catalog.id}>
						{catalog.name}
					</option>
				))}
			</optgroup>
			<optgroup label="Печатные каталоги">
				{printed.map(catalog => (
					<option key={catalog.id} value={catalog.id}>
						{catalog.name}
					</option>
				))}
			</optgroup>
		</select>
	)
}
